<template>
  <v-app style="background: black">
    <v-card fluid>
      <div id="title">
        <img
          class="titleimg"
          height="500px"
          width="500px"
          src="../assets/images/newLogo.png"
          alt="loading..."
        />
      </div>
      <div id="loading">
        <img
          class="img"
          src="../assets/images/loading.gif"
          alt="loading..."
          width="200"
        />
      </div>
    </v-card>
  </v-app>
</template>

<script>
export default {
  name: 'EmptyLayout',
}
</script>
<style>
.titleimg {
  filter: gray; /* IE6-9 */
  -webkit-filter: grayscale(1); /* Google Chrome, Safari 6+ & Opera 15+ */
  filter: grayscale(1); /* Microsoft Edge and Firefox 35+ */
  /* margin-top: 10px; */
  /* position: absolute; */
  /* text-align: center; */
}
#loading {
  position: absolute;
  z-index: 1000;
  /* background-color: white; */
  height: 120vh;
  width: 100vw;
  text-align: center;
  line-height: 90vh;
}
#title {
  position: absolute;
  z-index: 1000;
  height: 120vh;
  width: 100vw;
  text-align: center;
  font-size: 30px;
  /* line-height: 90vh; */
  margin-top: 150px;
  /* background-color: white; */
}
.img {
  opacity: 50%;
  position: relative;
  /* margin: auto; */
  height: 80%;
  width: 80%;
  object-fit: cover;
  margin-bottom: 20%;
}
#root {
  /* background: linear-gradient(-90deg, rgb(98, 0, 234), rgb(236, 64, 122)); */
  background: linear-gradient(
    -90deg,
    #ee7752,
    #e73c7e,
    #23a6d5,
    #23d5ab,
    #23d5ab,
    #23a6d5,
    #e73c7e,
    #ee7752
  );
  background-size: 300% 300%;
  animation: gradient 5s ease infinite;
  height: 100vh;
}

@keyframes gradient {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 150% 100%;
  }
}
#tiles {
  display: inline-block;
  height: 5%;
  width: 5%;
  color: black;
}
</style>
